module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.onScroll),
      expression: "onScroll"
    }],
    staticClass: "fl ovf-auto",
    style: ('width:' + _vm.width + ';height:' + _vm.height),
    on: {
      "mousemove": function($event) {
        _vm.dragMove($event)
      }
    }
  }, [_c('div', {
    staticClass: "ele-list w-100",
    on: {
      "mouseup": function($event) {
        _vm.dragUp($event, false)
      }
    }
  }, _vm._l((_vm.eleList), function(item, index) {
    return _c('div', {
      staticClass: "ele",
      class: {
        'active': _vm.curEle.type == item.type && item.type == _vm.TYPE_ROUTE
      },
      on: {
        "mousedown": function($event) {
          _vm.dragDown($event, item, 'add')
        }
      }
    }, [_c('div', {
      class: _vm.getNodeClass(item.type)
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "paper-wrapper pos-rel",
    style: (_vm.paperSize)
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.delRouteBtn.show),
      expression: "delRouteBtn.show"
    }],
    staticClass: "del-route",
    style: (_vm.delRouteBtn.pos)
  }, [_c('span', {
    on: {
      "click": _vm.deleteRoute
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('svg', {
    staticClass: "route-paper",
    on: {
      "mousedown": _vm.resetRoute
    }
  }, [_c('defs', [_c('marker', {
    attrs: {
      "id": "arrow1",
      "viewBox": "0 0 6 6",
      "refX": "5",
      "refY": "3",
      "markerUnits": "strokeWidth",
      "markerWidth": "6",
      "markerHeight": "6",
      "orient": "auto"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 0 0 L 6 3 L 0 6 z",
      "fill": "#0080d3",
      "stroke-width": "0"
    }
  })]), _vm._v(" "), _c('marker', {
    attrs: {
      "id": "arrow2",
      "viewBox": "0 0 6 6",
      "refX": "5",
      "refY": "3",
      "markerUnits": "strokeWidth",
      "markerWidth": "6",
      "markerHeight": "6",
      "orient": "auto"
    }
  }, [_c('path', {
    attrs: {
      "d": "M 0 0 L 6 3 L 0 6 z",
      "fill": "#ff3300",
      "stroke-width": "0"
    }
  })])]), _vm._v(" "), _c('g', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "from": "",
      "to": ""
    }
  }, [_c('path', {
    attrs: {
      "visibility": "hidden",
      "stroke-width": "9",
      "fill": "none",
      "stroke": "white",
      "d": "M 126 93 L 563 166",
      "pointer-events": "stroke"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "stroke-dasharray": "6,5"
    },
    attrs: {
      "d": _vm.tempRoute.path,
      "stroke-width": "1.4",
      "stroke-linecap": "round",
      "fill": "none",
      "stroke": "#ff3300",
      "marker-end": "url(#arrow2)"
    }
  })]), _vm._v(" "), _vm._l((_vm.routeList), function(route, index) {
    return _c('g', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "from": "",
        "to": ""
      },
      on: {
        "click": function($event) {
          _vm.selectRoute($event, index, route)
        }
      }
    }, [(_vm.curRouteIndex == index) ? [_c('path', {
      attrs: {
        "visibility": "hidden",
        "stroke-width": "20",
        "fill": "none",
        "stroke": "white",
        "d": route.path,
        "pointer-events": "stroke"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": route.path,
        "stroke-width": "1.4",
        "stroke-linecap": "round",
        "fill": "none",
        "stroke": "#ff3300",
        "marker-end": "url(#arrow2)"
      }
    })] : [_c('path', {
      attrs: {
        "visibility": "hidden",
        "stroke-width": "20",
        "fill": "none",
        "stroke": "white",
        "d": route.path,
        "pointer-events": "stroke"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": route.path,
        "stroke-width": "1.4",
        "stroke-linecap": "round",
        "fill": "none",
        "stroke": "#0080d3",
        "marker-end": "url(#arrow1)"
      }
    })], _vm._v(" "), _vm._v(" "), _c('text', {
      staticStyle: {
        "cursor": "text"
      },
      attrs: {
        "text-anchor": "middle",
        "x": (route.start_x + route.end_x) / 2,
        "y": (route.start_y + route.end_y) / 2,
        "fill": "black"
      }
    }, [_vm._v(_vm._s(route.remark))])], true)
  })], true), _vm._v(" "), _c('div', {
    staticClass: "draw-paper h-100p",
    on: {
      "mouseup": function($event) {
        _vm.dragUp($event, true)
      }
    }
  }, [_vm._l((_vm.nodeList), function(item, index) {
    return _c('div', {
      staticClass: "draw-node",
      class: [_vm.getNodeClass(item.type), {
        'crosshair': _vm.curEle.type == _vm.TYPE_ROUTE,
        'active': _vm.curNode.iden == item.iden
      }],
      style: ([item.pos, item.size]),
      on: {
        "mousedown": function($event) {
          _vm.dragDown($event, item, 'move')
        },
        "mouseup": function($event) {
          _vm.dragUp($event, true, item)
        },
        "click": function($event) {
          _vm.selectNode(item)
        },
        "dblclick": _vm.dbclickEvent
      }
    }, [(item.type != 10) ? _c('span', {
      staticClass: "del-node",
      on: {
        "mousedown": function($event) {
          _vm.confirmDeleteNode($event, item, index)
        }
      }
    }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "node-name text-overflow",
      on: {
        "dblclick": _vm.editRemark
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }, {
        name: "show",
        rawName: "v-show",
        value: (item.edit),
        expression: "item.edit"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm._s(item.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.name = $event.target.value
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "resizer",
      on: {
        "mousedown": function($event) {
          _vm.dragDown($event, item, 'resize')
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "draw-node temp-node",
    class: _vm.getNodeClass(_vm.tempNode.type),
    style: (_vm.tempNode.pos)
  }, [_c('span', {
    staticClass: "node-name"
  }, [_vm._v(_vm._s(_vm.tempNode.name))])])], true)]), _vm._v(" "), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.delShow),
      expression: "delShow"
    }],
    attrs: {
      "title": "提示",
      "size": "tiny"
    },
    domProps: {
      "value": (_vm.delShow)
    },
    on: {
      "input": function($event) {
        _vm.delShow = $event
      }
    }
  }, [_c('span', [_vm._v("是否删除该节点？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.delShow = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.deleteNode
    }
  }, [_vm._v("确 定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b4e6ccb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/abstract/nodePaper.vue
// module id = 1853
// module chunks = 2